unit ActionsPage;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WebForm.Core,
  BaseSitePage,
  BaseList;

type
  TActionsForm = class(TBaseSiteForm)
    btnSendNewInvitations: TButton;
    btnResendInvitations: TButton;
    btnSendAnnualInvitations: TButton;
    procedure OnClick_SendNewInvitations(Sender: TObject);
    procedure OnClick_ResendInvitationLetters(Sender: TObject);
    procedure OnClick_SendAnnualInvitations(Sender: TObject);
  private
    { Private declarations }

    [async]
    procedure SendInvitations(aOptions: JS.TJSObject); async;

  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  ActionsForm: TActionsForm;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  MainDataModule,
  App.Server.Responses,
  Web.Response.Utils;

procedure TActionsForm.OnClick_ResendInvitationLetters(Sender: TObject);
var
  jsoData: JS.TJSObject;

begin
  jsoData := TJSObject.new;
  jsoData['ResendInvites'] := True;

  SendInvitations(jsoData);

end;

procedure TActionsForm.OnClick_SendAnnualInvitations(Sender: TObject);
var
  jsoData: JS.TJSObject;

begin
  MessageDlg(
    'This will reset the status of all schools and generate new invitation letters.' + sLineBreak +
    'Are you sure you wish to proceed?',
    mtConfirmation,
    [mbYes, mbNo],
    procedure(Res: TModalResult)
    begin
      if Res = mrYes then
      begin
        jsoData := TJSObject.new;
        jsoData['SendAnnualInvites'] := True;

        SendInvitations(jsoData);

      end;

    end
  );

end;

procedure TActionsForm.OnClick_SendNewInvitations(Sender: TObject);
var
  jsoData: JS.TJSObject;

begin
  jsoData := TJSObject.new;
  jsoData['SendNew'] := True;

  SendInvitations(jsoData);

end;

procedure TActionsForm.SendInvitations(aOptions: JS.TJSObject);
const
  SC_SendInvitations = 'ISchoolService.SendInvitations';

var
  oClientResponse: TXDataClientResponse;
  bSuccess: Boolean;
  iIdx: Integer;
  jsaResponseList: JS.TJSArray;
  jsoServerResponse: JS.TJSObject;
  aStatusLines: TArray<string>;

begin
  oClientResponse := Await(
    TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync(
      SC_SendInvitations,
      [ TJSJSON.stringify(aOptions) ]
    )
  );

  jsaResponseList := JS.toArray(oClientResponse.ResultAsObject['ServerResponses']);
  SetLength(aStatusLines, jsaResponseList.Length);
  bSuccess := True;

  for iIdx := 0 to jsaResponseList.Length - 1 do
  begin
    jsoServerResponse := JS.toObject(jsaResponseList[iIdx]);

    bSuccess := bSuccess and JS.toBoolean(jsoServerResponse['Success']);
    aStatusLines[iIdx] := JS.toString(jsoServerResponse['Status']);

  end;

  ShowMessage(BuildServerResponseMessage(bSuccess, aStatusLines));

end;

procedure TActionsForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  btnSendNewInvitations := TButton.Create('send-new-invitations');
  btnResendInvitations := TButton.Create('resend-invitations');
  btnSendAnnualInvitations := TButton.Create('send-annual-invitations');

  btnSendNewInvitations.BeforeLoadDFMValues;
  btnResendInvitations.BeforeLoadDFMValues;
  btnSendAnnualInvitations.BeforeLoadDFMValues;
  try
    Name := 'ActionsForm';
    Left := 0;
    Top := 0;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    btnSendNewInvitations.SetParentComponent(Self);
    btnSendNewInvitations.Name := 'btnSendNewInvitations';
    btnSendNewInvitations.Left := 48;
    btnSendNewInvitations.Top := 32;
    btnSendNewInvitations.Width := 217;
    btnSendNewInvitations.Height := 25;
    btnSendNewInvitations.Caption := 'Send New Invitation Letters';
    btnSendNewInvitations.ElementClassName := 'btn btn-light';
    btnSendNewInvitations.ElementFont := efCSS;
    btnSendNewInvitations.HeightStyle := ssAuto;
    btnSendNewInvitations.HeightPercent := 100.000000000000000000;
    btnSendNewInvitations.WidthPercent := 100.000000000000000000;
    SetEvent(btnSendNewInvitations, Self, 'OnClick', 'OnClick_SendNewInvitations');
    btnResendInvitations.SetParentComponent(Self);
    btnResendInvitations.Name := 'btnResendInvitations';
    btnResendInvitations.Left := 48;
    btnResendInvitations.Top := 63;
    btnResendInvitations.Width := 217;
    btnResendInvitations.Height := 25;
    btnResendInvitations.Caption := 'Resend Invitation Letters';
    btnResendInvitations.ChildOrder := 1;
    btnResendInvitations.ElementClassName := 'btn btn-light';
    btnResendInvitations.ElementFont := efCSS;
    btnResendInvitations.HeightStyle := ssAuto;
    btnResendInvitations.HeightPercent := 100.000000000000000000;
    btnResendInvitations.WidthPercent := 100.000000000000000000;
    SetEvent(btnResendInvitations, Self, 'OnClick', 'OnClick_ResendInvitationLetters');
    btnSendAnnualInvitations.SetParentComponent(Self);
    btnSendAnnualInvitations.Name := 'btnSendAnnualInvitations';
    btnSendAnnualInvitations.Left := 48;
    btnSendAnnualInvitations.Top := 94;
    btnSendAnnualInvitations.Width := 217;
    btnSendAnnualInvitations.Height := 25;
    btnSendAnnualInvitations.Caption := 'Send Annual Invitation Letters';
    btnSendAnnualInvitations.ChildOrder := 1;
    btnSendAnnualInvitations.ElementClassName := 'btn btn-light';
    btnSendAnnualInvitations.ElementFont := efCSS;
    btnSendAnnualInvitations.HeightStyle := ssAuto;
    btnSendAnnualInvitations.HeightPercent := 100.000000000000000000;
    btnSendAnnualInvitations.WidthPercent := 100.000000000000000000;
    SetEvent(btnSendAnnualInvitations, Self, 'OnClick', 'OnClick_SendAnnualInvitations');
  finally
    btnSendNewInvitations.AfterLoadDFMValues;
    btnResendInvitations.AfterLoadDFMValues;
    btnSendAnnualInvitations.AfterLoadDFMValues;
  end;
end;

end.